@if (!hidden()) {
  <div class="container">
    @if (label(); as label) {
      <onyx-input-label
        [label]="label"
        [hint]="hint()"
        [required]="required()"
        [disabled]="disabled()"
        (click)="focus()"
      ></onyx-input-label>
    }

    <div
      class="wrapper size-{{ size() }}"
      [class.invalid]="isInvalid()"
      [class.disabled]="disabled()"
      [class.active]="areaCode() && phoneNumber()"
    >
      <div
        class="dropdown"
        [class.expanded]="expanded()"
        [tabindex]="disabled() ? -1 : 0"
        [onyxDropdownOptions]="options$ | async"
        [onyxDropdownValue]="areaCode()"
        [(onyxDropdownAttached)]="expanded"
        [onyxDropdownSearch]="true"
        [onyxDropdownSearchKeys]="['value', 'countryCode']"
        [onyxDropdownDisabled]="disabled()"
        [onyxDropdownOptionTemplateRef]="dropdownOptionTemplate"
        (onyxDropdownSelectedOptionChange)="
          setAreaCode($any($event.option) ?? null)
        "
        (focusout)="touch.emit()"
      >
        @if (countryCode(); as countryCode) {
          <onyx-flag [countryCode]="countryCode"></onyx-flag>
        }

        <onyx-icon
          class="arrow"
          name="arrow-alt-down-outlined"
          [size]="20"
        ></onyx-icon>
      </div>

      <div class="separator"></div>

      <input
        type="text"
        [tabindex]="disabled() ? -1 : 0"
        [value]="phoneNumber()"
        placeholder="000 000 000"
        [disabled]="disabled()"
        (input)="handleValueChange($event)"
        (paste)="pasteNumber($event)"
        #inputElement
      />

      @if (phoneNumber() && !disabled()) {
        <onyx-clear-button (click)="clearNumber()"></onyx-clear-button>
      }
    </div>
  </div>

  @let control = formField() ?? formControl();
  @if (control && showErrors()) {
    <onyx-error [errors]="[control]" variant="control"></onyx-error>
  }
}

<ng-template let-option="option" let-query="query" #dropdownOptionTemplate>
  <div class="dropdown-option">
    <p [innerHTML]="option.name | onyxHighlight: query"></p>
    <p class="area-code" [innerHTML]="option.value | onyxHighlight: query"></p>
  </div>
</ng-template>
